import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "overlay"]

  toggle() {
    this.containerTarget.classList.toggle("expanded")

    if (this.containerTarget.classList.contains("expanded")) {
      this.overlayTarget.querySelector("button").textContent = "閉じる"
    } else {
      this.overlayTarget.querySelector("button").textContent = "もっと見る"
    }
  }
}
